import * as React from "react";
import { extend, createPortal } from "@react-three/fiber";
import { OculusHandModel } from "./OculusHandModel.js";
import { useXR } from "./XR.js";
import { useIsomorphicLayoutEffect } from "./utils.js";
function Hands({ modelLeft, modelRight }) {
  const controllers = useXR((state) => state.controllers);
  React.useMemo(() => extend({ OculusHandModel }), []);
  useIsomorphicLayoutEffect(() => {
    for (const target of controllers) {
      target.hand.dispatchEvent({ type: "connected", data: target.inputSource, fake: true });
    }
  }, [controllers, modelLeft, modelRight]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, controllers.map(({ hand }) => createPortal(/* @__PURE__ */ React.createElement("oculusHandModel", {
    args: [hand, modelLeft, modelRight]
  }), hand)));
}
export {
  Hands
};
//# sourceMappingURL=Hands.js.map
